import React, { useRef, useEffect } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

const Modal = ({
  title,
  message,
  type = 'alert',
  confirmText = 'OK',
  cancelText = 'Cancel',
  onClose,
}) => {
  const modalRef = useRef(null);

  // Focus trap and escape key handler
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        onClose(false);
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  // Prevent scrolling on body when modal is open
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  // Handle modal click
  const handleModalClick = (e) => {
    if (modalRef.current && !modalRef.current.contains(e.target)) {
      onClose(false);
    }
  };

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50"
      onClick={handleModalClick}
    >
      <div
        ref={modalRef}
        className="mx-4 w-full max-w-md transform rounded-lg bg-white shadow-xl transition-all"
        role="dialog"
        aria-modal="true"
      >
        <div className="flex items-center justify-between border-b px-6 pb-2 pt-5">
          <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
          <button onClick={() => onClose(false)} className="text-gray-400 hover:text-gray-500">
            <XMarkIcon className="h-5 w-5" />
          </button>
        </div>

        <div className="p-6">
          <p className="text-base text-gray-500">{message}</p>
        </div>

        <div className="flex flex-row-reverse gap-3 rounded-b-lg bg-gray-50 px-6 py-4">
          <button onClick={() => onClose(true)} className="btn-primary">
            {confirmText}
          </button>

          {type === 'confirm' && (
            <button onClick={() => onClose(false)} className="btn-secondary">
              {cancelText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Modal;
